<template>
  <div class="container g-0 m-0">
    <div class="background-partners align-items-center d-flex justify-content-center">

      <div class="text-center btn-holder" @click="goBack()">
        <div class="bk-btn">
            <div class="bk-btn-triangle"></div>
            <div class="bk-btn-bar"></div>
        </div>
        <p>Voltar</p>
      </div>

      <div class="maintenance-text text-center">
        <img src="@\assets\images\em-manutencao.jpg" width="400" alt="">
        <div class="text-holder">
          <p>Página em manutenção!</p>
          <p class="mb-0">Em breve teremos novidades!</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script scoped>

  export default {
    name: 'App',
    components: {
    },
    methods: {
      goBack() {
        window.history.back()
      }
    }
  }
  </script>
  
  <style scoped>
  
  .background-partners {
    width: 100%;
    height: 100%;
    position: absolute;
  }
  
  .maintenance-text {
    font-family: Montserrat Bold;
  }
  
  .text-holder {
    border-radius: 40px;
    padding: 30px 30px;
    background-color: #fb7149;
  }
  
  .text-holder p {
    color: rgb(32, 32, 32);
    line-height: 30px;
    font-size: 40px;
  }
  .btn-holder {
    cursor: pointer;
    
    width: 52px;
    top: 40px;
    left: 40px;
    position: absolute;
  }
  
  .btn-holder p {
    font-family: Montserrat Bold;
    font-size: 20px;
  }
  
  .bk-btn {
    height: 52px;
    width: 52px;
    background-color: #fb7149;
    border-radius: 50%;
  }
  
  .bk-btn-triangle {
    position: relative;
    top: calc(52px*0.25);
    left: calc(52px*0.2);
    width: 0;
    height: 0;
    border-top: calc(52px*0.25) solid transparent;
    border-bottom: calc(52px*0.25) solid transparent;
    border-right: calc(52px*0.25) solid white;
  }
  .bk-btn-bar {
    position: relative;
    background-color: white;
    height: calc(52px*0.15);
    width: calc(82px*0.25);
    top: calc(-58px*0.07);
    left: calc(52px*0.44);
  }
  
  </style>